module.exports = __webpack_public_path__ + "img/microphone.eb7aad38.svg";